import { useState, useEffect, useRef } from "react";
import { io } from "socket.io-client";
import { useConfig } from "providers/ConfigProvider";

export default function useSocket() {
  const { apiUrl } = useConfig();
  const [isAuthed, setIsAuthed] = useState(false);
  const socket = useRef();

  if (!socket.current) {
    socket.current = io(apiUrl, {
      withCredentials: true,
    });
    socket.current.on("auth", ({ success }) => setIsAuthed(success));
  }

  useEffect(() => {
    return () => {
      socket.current?.disconnect();
      socket.current = null;
      setIsAuthed(false);
    };
  }, []);

  return [socket.current, isAuthed];
}
